import { GroupLead, GroupLeadRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const assignGroupLeads: (
  fetchContext: FetchContext,
  groupId: number,
  groupLead: GroupLead,
  accessToken?: string,
) => Promise<GroupLeadRef> = (fetchContext, groupId, groupLead, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/groups/${groupId}/leads`,
  {
    method: 'POST',
    body: JSON.stringify(groupLead),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<GroupLeadRef>(fetchContext.errorStore, response, 'assign group leads'));
